<template>
  <div :class="$style.headerContainer">
    <div :class="$style.categoriesList">
      <div
        v-for="category in categories"
        :key="category.name"
        :class="$style.categoryDescription"
      >
        <p :class="[$style[category.style], $style.descriptionHeader]">
          {{ `${category.qty} ${item}` }}
        </p>
        <p>
          {{ category.name }}
        </p>
      </div>
    </div>
    <div data-test-id="totalSection">
      <span :class="$style.totalAmount">{{ total }}</span> total {{ totalText }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummaryGraphHeader',

  props: {
    categories: {
      type: Array,
      required: true,
    },
    item: {
      type: String,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    totalText: {
      type: String,
      required: true,
    },
  },
};
</script>

<style module>
@import "./css/SummaryGraph.css";
</style>
